import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { PsaService } from "../../../create-application/psa-form/psa.service";
import { FileUpload } from "primeng/primeng";
import { FileUploadService } from "../../../shared/services/file-upload.service";
import { LoginService } from "../../../shared/services/login.service";
import { UploadfilesViewmodel } from "../../../shared/viewmodels/uploadfiles-viewmodel";
import { Observable } from "rxjs";
import { UploadFileInformation } from "../../../shared/data-objects/upload-file-information";
import { FindValueSubscriber } from "rxjs/operators/find";
import { UploadFile2Information } from "shared/data-objects/upload-file2-information";

@Component({
  selector: "app-upload-file2",
  templateUrl: "./upload-file2.component.html",
  styleUrls: ["./upload-file2.component.css"],
})
export class UploadFile2Component implements OnInit {
  fileListComponent: any[];
  attachmentType: string;
  attachmentTypeList: string[];
  submitErrorMessage: any[];
  isPumpCurveAvailable: boolean = false;
  validationMessage:string

  @Input() uploadfilesViewmodel: UploadfilesViewmodel;
  
  constructor(
    private loginService: LoginService,
    private fileUploadService: FileUploadService,
    private psaService: PsaService
  ) {
    const reg: any = "(http(s)?://)?([\\w-]+\\.)+[\\w-]+[.com]+(/[/?%&=]*)?";
    this.fileListComponent = [];
    this.submitErrorMessage = [];

    this.psaService.onInLinePumpSelection.subscribe((v) => {
      if (v === "inLineYes") {
       this.isPumpCurveAvailable=true
       if(this.psaService.applicationData.planType === "BrownField"){
       this.validationMessage="Site plan, Pump Curves and Pump Information are mandatory"
       }
      } else {
        this.isPumpCurveAvailable=false
        if(this.psaService.applicationData.planType === "BrownField"){
        this.validationMessage="Site plan is mandatory"
        }
      }
    });



   

    this.psaService.onDevelopmentChange.subscribe((x) => {
      if (this.psaService.applicationData.planType === "BrownField") {
        this.attachmentTypeList = [
          "Site Plan",
          "Hydraulic Plans",
          "Architectural Plans",
          "Fire Service Plans",
          "Ground Anchors",
          "Pump Curves and Pump Information",
          "Plan of Subdivision",
          "Town Planning Plans",
          'Fire Rescue Victoria (FRV) report'
        ];

       


        this.psaService.fileList=null
      }
      if (this.psaService.applicationData.planType === "GreenField") {

        this.attachmentTypeList = [
          "Proposed Master Plan",
          "Plan of Subdivision",
          "Other plans outlining development/s"      
        ];
        this.psaService.fileList=null
        this.validationMessage=''
      }
    });

  }

  
  ngOnInit() {}
  addFiles(event: any): boolean {
    return this.doAddFiles(event);
  }

  isInvalid() {
    this.submitErrorMessage = [];

    let regexpNumber = new RegExp(
      "^([a-zA-Z0-9-_\\s])+(.pdf|.PDF)$"
    );

    if(this.attachmentType ==="Please Select..." && this.psaService.applicationData.planType === "GreenField"){
      return false
    }



    



    if (!this.uploadfilesViewmodel.files && this.attachmentType) {
      this.submitErrorMessage.push("Please Upload File");

      return true;
    }

    if(this.psaService.applicationData.planType === "BrownField") {

      if (!this.fileListComponent.find((x) => x.attachmentType === "Site Plan")) {
        this.submitErrorMessage.push("Please Upload Site Plan");
  
        return true;
      }
      if (this.isPumpCurveAvailable) {
        if (
          !this.fileListComponent.find(
            (x) => x.attachmentType === "Pump Curves and Pump Information"
          )
        ) {
          this.submitErrorMessage.push(
            "Please Upload Pump Curves and Pump Information Plan"
          );
  
          return true;
        }
      }
    }
 

    if(this.psaService.fileList){
    for (let i = 0; i < this.psaService.fileList.length; i++) {
      if (!regexpNumber.test(this.psaService.fileList[i].file.name)) {
        //this.uploadfilesViewmodel.files.splice(i, 1);
        this.submitErrorMessage.push(
          "File can be PDF and contain only alpha-numeric characters, spaces, underscores and dashes "
        );

        return true;
      }

      const fileSize: number = Number(
        (this.psaService.fileList[i].size / 1024 / 1024).toFixed(4)
      ); // MB
      if (
        this.psaService.fileList[i].name !== "item" &&
        typeof this.psaService.fileList[i].name !== "undefined" &&
        fileSize > 20
      ) {
        //this.uploadfilesViewmodel.files.splice(i, 1);
        this.submitErrorMessage.push(
          "Please limit individual files size to 20MB and ensure files are in a PDF format."
        );

        return true;
      }
    }
  }

    

  }

  uploadFiles(): Observable<string[]> {
    return this.psaService.uploadFile(this.loginService.getToken());
  }

  updateFileInformation(uploadFileInfo: UploadFile2Information): Observable<boolean> {
    return this.psaService.updateFileInformation(uploadFileInfo, this.loginService.getToken());
  }
  doAddFiles(event): boolean {
   let files= event.target.files
   let regexpNumber = new RegExp(
    "^([a-zA-Z0-9-_\\s])+(.pdf|.PDF)$"
  );
   this.submitErrorMessage = [];


   if(this.attachmentType ==="Please Select..." || !this.attachmentType ){
    this.submitErrorMessage.push("Please Select Plan Type");
    return;
  }

  if(files){
    for (let i = 0; i < files.length; i++) {
      if (!regexpNumber.test(files[i].name)) {
        //this.uploadfilesViewmodel.files.splice(i, 1);
        this.submitErrorMessage.push(
          "File can be PDF and contain only alpha-numeric characters, spaces, underscores and dashes "
        );

        return
      }

      const fileSize: number = Number(
        (files[i].size / 1024 / 1024).toFixed(4)
      ); // MB
      if (
        files[i].name !== "item" &&
        files[i].name !== "undefined" &&
        fileSize > 20
      ) {
        //this.uploadfilesViewmodel.files.splice(i, 1);
        this.submitErrorMessage.push(
          "Please limit individual files size to 20MB and ensure files are in a PDF format."
        );

        return
      }

      /*
      if(this.fileListComponent.find(x=> x.attachmentType === this.attachmentType))
      {
        this.submitErrorMessage.push(
          "File Has been already added for this plan Type"
        );
        return 
      }
      */

      if(this.fileListComponent.find(x=> x.file.name === files[i].name))
      {
        this.submitErrorMessage.push(
          `File name "${files[i].name}" already exists in the list, please use use a different file name.`
        );
        return 
      }

    }
  }

 


    if (files.length > 0) {
      this.submitErrorMessage = [];
    
      this.uploadfilesViewmodel.files = files; // puts all files into an array
      this.uploadfilesViewmodel.files.attachmentType = this.attachmentType;

      

      this.fileListComponent.push({
        attachmentType: this.attachmentType,
        file: files.item(0),
      });


      this.psaService.addFile(this.fileListComponent); 
 

      event.target.value=""
      return this.uploadfilesViewmodel.files.length > 0;
    }

    
  
  }

  set selectedValue(v: string) {
    this.attachmentType = v;
  }

  removeItem(v) {
 
    if (this.fileListComponent) {
      let index = this.fileListComponent.indexOf(v);
      this.fileListComponent = this.fileListComponent.filter((val, i) => i != index);
      this.psaService.fileList= this.fileListComponent
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-file2/upload-file2.component.ts